import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadCourses,
  saveCourses,
  deleteCourses,
  clearAjaxCall
} from '../actions/Courses'
import { loadInstructors } from '../actions/Instructors'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import CoursesDetails from './Courses/CoursesDetails'
import EditCourse from './Courses/EditCourse'
import DeleteCourse from './Courses/DeleteCourse'

import { grant } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  course: {}
}

class Courses extends Component {
  constructor() {
    super()
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.courses.list === null) {
      this.reloadCourses()
    }
    if (this.props.instructors.list === null) {
      this.props.loadInstructors()
    }
  }
  showDelete(course) {
    this.setState({ showDelete: true, course })
  }
  showEdit(course) {
    this.setState({
      showEdit: true,
      course: { ...course, start_time: '', end_time: '' }
    })
  }
  newCourse() {
    this.setState({
      showEdit: true,
      course: {
        id: null,
        name: '',
        color: '',
        day_of_week: '',
        instructorid: '',
        start_time: '',
        end_time: '',
        notes: '',
        schedule_list: []
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadCourses() {
    this.props.loadCourses()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.courses.ajaxSpinner &&
      !this.props.courses.ajaxSpinner &&
      this.props.courses.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.courses.ajaxSpinner &&
      !this.props.courses.ajaxSpinner &&
      this.props.courses.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, error, loading, ajaxSpinner } = this.props.courses
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Corsi</div>
          <div className='ph-descr txt'>
            Assegna un colore ad ogni corso in modo da rendere più facile
            indentificare iscritti e ricevute.
          </div>
          <ul className='ph-btn'>
            {grant() && (
              <li>
                <button onClick={() => this.newCourse()} className='lnk-tools'>
                  <i className='fas fa-clipboard'></i> aggiungi
                </button>
              </li>
            )}
            <li>
              <button
                onClick={() => this.reloadCourses()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {list !== null &&
              list.length + (list.length === 1 ? ' risultato' : ' risultati')}
            {list === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {list !== null &&
          list.map((c, index) => {
            return (
              <CoursesDetails
                key={index}
                course={c}
                showDelete={this.showDelete}
                showEdit={this.showEdit}
              />
            )
          })}
        {this.state.showEdit && (
          <EditCourse course={this.state.course} hideModal={this.hideModal} />
        )}
        {this.state.showDelete && (
          <DeleteCourse course={this.state.course} hideModal={this.hideModal} />
        )}
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadCourses,
  saveCourses,
  deleteCourses,
  loadInstructors,
  clearAjaxCall
})(Courses)



// WEBPACK FOOTER //
// ./src/components/Courses.js